// extracted by mini-css-extract-plugin
export default {"root":"_404_root__OVE9E"};